/*@ngInject*/
const ExternalContentController = function ($scope, $stateParams) {
    $scope.viewModel = {
        externalContentUrl: $stateParams.externalContentUrl,
        externalContentPopoutUrl: $stateParams.externalContentPopoutUrl
    };
};

angular.module('gw-um-submission')
    .controller('externalContentController', ExternalContentController);
